import { QuizzSentence, QuizzType } from '@/types/Quizz'

const quizzSentences: QuizzSentence[] = [
  {
    id: 1,
    type: QuizzType.QCM,
    question: 'quizz.questions.1.title',
    description: 'quizz.questions.1.description',
    answers: [
      {
        id: 1,
        answer: 'quizz.questions.1.answers.1',
      },
      {
        id: 2,
        answer: 'quizz.questions.1.answers.2',
      },
      {
        id: 3,
        answer: 'quizz.questions.1.answers.3',
      },
    ],
    correctAnswers: [1],
    justification: {
      items: ['quizz.questions.1.justifications.1'],
      references: [1, 2],
    },
  },
  {
    id: 2,
    type: QuizzType.QCM,
    question: 'quizz.questions.2.title',
    description: 'quizz.questions.2.description',
    answers: [
      {
        id: 1,
        answer: 'quizz.questions.2.answers.1',
      },
      {
        id: 2,
        answer: 'quizz.questions.2.answers.2',
      },
      {
        id: 3,
        answer: 'quizz.questions.2.answers.3',
      },
    ],
    correctAnswers: [3],
    justification: {
      items: ['quizz.questions.2.justifications.1'],
      references: [3, 4, 1, 2, 5],
    },
  },
  {
    id: 3,
    type: QuizzType.QCM,
    question: 'quizz.questions.3.title',
    description: 'quizz.questions.3.description',
    answers: [
      {
        id: 1,
        answer: 'quizz.questions.3.answers.1',
      },
      {
        id: 2,
        answer: 'quizz.questions.3.answers.2',
      },
      {
        id: 3,
        answer: 'quizz.questions.3.answers.3',
      },
    ],
    correctAnswers: [1, 2],
    justification: {
      items: ['quizz.questions.3.justifications.1'],
      references: [6, 7, 2, 8, 9, 10, 12],
    },
  },
  {
    id: 4,
    type: QuizzType.QCM,
    question: 'quizz.questions.4.title',
    description: 'quizz.questions.4.description',
    answers: [
      {
        id: 1,
        answer: 'quizz.questions.4.answers.1',
      },
      {
        id: 2,
        answer: 'quizz.questions.4.answers.2',
      },
      {
        id: 3,
        answer: 'quizz.questions.4.answers.3',
      },
    ],
    correctAnswers: [1, 2],
    justification: {
      items: ['quizz.questions.4.justifications.1'],
      references: [6, 7, 2, 8, 9, 10, 12, 11, 13],
    },
  },
  {
    id: 5,
    type: QuizzType.QCM,
    question: 'quizz.questions.5.title',
    description: 'quizz.questions.5.description',
    answers: [
      {
        id: 1,
        answer: 'quizz.questions.5.answers.1',
      },
      {
        id: 2,
        answer: 'quizz.questions.5.answers.2',
      },
      {
        id: 3,
        answer: 'quizz.questions.5.answers.3',
      },
    ],
    correctAnswers: [2],
    justification: {
      items: ['quizz.questions.5.justifications.1'],
      references: [5, 14, 15, 16, 17, 11],
    },
  },
  {
    id: 6,
    type: QuizzType.QCM,
    question: 'quizz.questions.6.title',
    description: 'quizz.questions.6.description',
    answers: [
      {
        id: 1,
        answer: 'quizz.questions.6.answers.1',
      },
      {
        id: 2,
        answer: 'quizz.questions.6.answers.2',
      },
      {
        id: 3,
        answer: 'quizz.questions.6.answers.3',
      },
    ],
    correctAnswers: [2, 3],
    justification: {
      items: [
        [
          'quizz.questions.6.justifications.1',
          'quizz.questions.6.justifications.2',
          'quizz.questions.6.justifications.3',
          'quizz.questions.6.justifications.4',
          'quizz.questions.6.justifications.5',
        ],
      ],
      references: [6, 7, 2, 8, 9, 10, 12, 11, 13, 18, 19, 17, 14, 20],
    },
  },
  {
    id: 7,
    type: QuizzType.ILLUSTRATION,
    question: 'quizz.questions.7.title',
    description: 'quizz.questions.7.description',
    answers: [
      {
        id: 1,
        answer: 'quizz.questions.7.answers.1',
      },
      {
        id: 2,
        answer: 'quizz.questions.7.answers.2',
      },
      {
        id: 3,
        answer: 'quizz.questions.7.answers.3',
      },
      {
        id: 4,
        answer: 'quizz.questions.7.answers.4',
      },
    ],
    correctAnswers: [4, 3, 2, 1],
    justification: {
      items: ['quizz.questions.7.justifications.1'],
      references: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
    },
  },
]

export const quizz: QuizzSentence[][] = [
  [
    quizzSentences[0],
    quizzSentences[1],
    quizzSentences[2],
    quizzSentences[4],
    quizzSentences[6],
  ],
  [
    quizzSentences[0],
    quizzSentences[1],
    quizzSentences[3],
    quizzSentences[5],
    quizzSentences[6],
  ],
  [
    quizzSentences[0],
    quizzSentences[2],
    quizzSentences[4],
    quizzSentences[5],
    quizzSentences[6],
  ],
]

export const quizzQcmReferences: { [key: string]: string } = {
  1: 'Habtezion A, Nguyen LP, Hadeiba H, <em>et al.</em> Gastroenterology. 2016;150:340–54.',
  2: 'Eksteen B, Liaskou E, Adams DH. Inflamm Bowel Dis. 2008;14:1298–312.',
  3: 'Carman CV, Martinelli R. Front Immunol. 2015;6:603.',
  4: 'Kogan AN, von Andrian, UH. Lymphocyte Trafficking. In: Tuma RF, Durán WN, Ley K, eds. Microcirculation. 2nd edition. San Diego, CA: Elsevier Inc; 2008:449–82.',
  5: 'Zundler S, Becker E, Schulze LL, <em>et al.</em> Gut. 2019;68:1688–700.',
  6: 'Neurath MF. Nat Rev Immunol. 2014;14:329–42.',
  7: 'Bamias G, Cominelli F. Clin Gastroenterol Hepatol. 2020;S1542-3565(20)31283-0.',
  8: 'Arseneau KO, Cominelli F. Clin Pharmacol Ther. 2015;97:22–8.',
  9: 'Silva FA, Rodrigues BL, Ayrizono ML, <em>et al.</em> Gastroenterol Res Pract. 2016;2016:2097274;',
  10: 'Zundler S, Becker E, Schulze LL, <em>et al.</em> Gut. 2019;68:1688–700;',
  11: 'Neurath MF. Nat Immunol. 2019;20:970–9',
  12: 'Allez M, Tieng V, Nakazawa A, <em>et al.</em> Gastroenterology. 2007;132:2346-58.',
  13: 'Pariente B, Cosnes J, Danese S, <em>et al.</em> Inflamm Bowel Dis. 2011;17:1415–22.',
  14: 'Arijs I, De Hertogh G, Lemmens B, <em>et al.</em> Gut. 2018;67:43–52.',
  15: 'Fischer A, Zundler S, Atreya R, <em>et al.</em> Gut. 2016;65:1642–64.',
  16: 'Briskin M, Winsor-Hines D, Shyjan A, <em>et al.</em> Am J Pathol. 1997;151:97-110.',
  17: 'Veny M, Garrido-Trigo A, Corraliza AM, <em>et al.</em> J Crohns Colitis. 2021;15:441-52.',
  18: 'Coletta M, Paroni M, Alvisi MF, <em>et al.</em> J Crohns Colitis. 2020;14:1190–201.',
  19: 'Rath T, Billmeier U, Ferrazzi F, <em>et al.</em> Front Immunol. 2018;9:1700.',
  20: 'Danese S, Sandborn WJ, Colombel J-F, <em>et al.</em> Gastroenterology. 2019;157:1007–18.',
}

export const quizzIllustrationReferences: { [key: string]: string } = {
  1: 'Arseneau KO, Cominelli F. Targeting leukocyte trafficking for the treatment of inflammatory bowel disease. Clin Pharmacol Ther. 2015 Jan;97(1):22-8. doi: 10.1002/cpt.6. Epub 2014 Dec 2. PMID: 25670380; PMCID: PMC4594846.',
  2: 'Eksteen B, Liaskou E, Adams DH. Lymphocyte homing and its role in the pathogenesis of IBD. Inflamm Bowel Dis. 2008 Sep;14(9):1298-312. doi: 10.1002/ibd.20453. PMID: 18393377.',
  3: 'Carman CV, Martinelli R. T Lymphocyte-Endothelial Interactions: Emerging Understanding of Trafficking and Antigen-Specific Immunity. Front Immunol. 2015 Nov 24;6:603. doi: 10.3389/fimmu.2015.00603. PMID: 26635815; PMCID: PMC4657048.',
  4: 'Entyvio Summary of Product Characteristics. 2022.',
  5: 'Habtezion A, Nguyen LP, Hadeiba H, Butcher EC. Leukocyte Trafficking to the Small Intestine and Colon. Gastroenterology. 2016 Feb;150(2):340-54. doi: 10.1053/j.gastro.2015.10.046. Epub 2015 Nov 6. PMID: 26551552; PMCID: PMC4758453.',
  6: 'Humira. Summary of Product Characteristics. 2022.',
  7: 'Coletta M, Paroni M, <em>et al.</em> Immunological Variables Associated With Clinical and Endoscopic Response to Vedolizumab in Patients With Inflammatory Bowel Diseases. J Crohns Colitis. 2020 Sep 16;14(9):1190-1201. doi: 10.1093/ecco-jcc/jjaa035. Erratum in: J Crohns Colitis. 2021 Nov 30;: PMID: 32100016.',
  8: 'Neurath MF. Cytokines in inflammatory bowel disease. Nat Rev Immunol. 2014 May;14(5):329-42. doi: 10.1038/nri3661. Epub 2014 Apr 22. PMID: 24751956.',
  9: 'Remicade. Summary of Product Characteristics. 2022.',
  10: 'Simponi. Summary of Product Characteristics. 2021.',
  11: 'Stelara. Summary of Product Characteristics. 2022.',
  12: 'Xeljanz. Summary of Product Characteristics. 2022.',
  13: 'Zeposia. Prescribing Information. 2021.',
}

